import { render, staticRenderFns } from "./RecomPromoCodeEdit.vue?vue&type=template&id=4a31cc8a"
import script from "./RecomPromoCodeEdit.vue?vue&type=script&lang=js"
export * from "./RecomPromoCodeEdit.vue?vue&type=script&lang=js"
import style0 from "./RecomPromoCodeEdit.vue?vue&type=style&index=0&id=4a31cc8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports